// 使用者設定 component

<template>
  <div>
    <div class="upper-subpanel">
      <router-view/>
    </div>
    <bottom-buttons>
      <action-button slot="button-1" title="回主畫面" @click.native="cancel"/>
    </bottom-buttons>

  </div>
</template>

<script>
import BottomButtons from './common/BottomButtons';

export default {
  name: 'UserManual',
  data() {
    return {
      barcode: '',
    };
  },
  components: {
    BottomButtons,
  },
  methods: {
    cancel() {
      if (this.$store.state.fingerprinterStatus === 'waiting_finger') {
        this.$store.dispatch('sendCancelFingerCaptureCommand');
      }
      this.$router.push({ name: 'Main' });
    },
  },
  mounted() {
    this.$store.commit('SET_APP', '使用者選項');
  },
};
</script>



<style lang="sass" scoped>
.user-manual-wrap
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%
  width: 100%

.upper-subpanel--inside
  width: 0
  height: 0
</style>





// WEBPACK FOOTER //
// UserManual.vue?47ce67b4